import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import { companyInfo } from '@/data/staticData';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sourcingxperts/artifacts/i24d4eko_logo-png.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section" data-testid="main-footer" role="contentinfo">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img src={LOGO_URL} alt="Ecovera Sourcing LLP" className="h-12 mb-6" width="120" height="48" />
            <p className="text-slate-400 mb-6 leading-relaxed">
              {companyInfo.name} - Your trusted end-to-end sourcing and trading partner. Delivering seamless product solutions from concept to delivery.
            </p>
            <div className="flex gap-4">
              <a 
                href={companyInfo.social.linkedin} 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 transition-colors" 
                data-testid="social-linkedin"
                aria-label="Follow us on LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href={companyInfo.social.twitter}
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 transition-colors" 
                data-testid="social-twitter"
                aria-label="Follow us on Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick links">
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="footer-link">Our Services</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/case-studies" className="footer-link">Case Studies</Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Services">
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="footer-link">Product Sourcing</Link></li>
              <li><Link to="/services" className="footer-link">Supplier Discovery</Link></li>
              <li><Link to="/services" className="footer-link">Quality Control</Link></li>
              <li><Link to="/services" className="footer-link">Supply Chain</Link></li>
              <li><Link to="/services" className="footer-link">Product Development</Link></li>
            </ul>
          </nav>

          {/* Contact Info */}
          <address className="not-italic">
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" aria-hidden="true" />
                <span className="text-slate-400">{companyInfo.address.full}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-500 flex-shrink-0" aria-hidden="true" />
                <a href={`tel:+${companyInfo.phoneLink}`} className="footer-link">{companyInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-500 flex-shrink-0" aria-hidden="true" />
                <a href={`mailto:${companyInfo.email}`} className="footer-link">{companyInfo.email}</a>
              </li>
            </ul>
          </address>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <nav className="flex gap-6 text-sm" aria-label="Legal links">
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
